import moment from "moment";
import { Cell } from "react-table";
import { BizType, MbOrg } from "src/api/organization/org-types";
import { BaseTooltip } from "src/components/BaseTooltip";
import DetailLink from "src/components/DetailLink";
import PagePath from "src/pagePath.json";
import { companyRegistrationHypen, corpHypen, ViewYmdFormat } from "src/utils";
import { BizLocationType } from "../../org-types";

const OrgColumns: any = [
  {
    Header: "계약자 ID",
    accessor: "id",
    width: 120,
    sticky: "left",
    Cell: (props: Cell<MbOrg>) => {
      const path = `${PagePath.organization.detail?.replace(":id", `${props.row.original.id}`)}`;
      return (
        <DetailLink to={path} className="text-underline">
          {props.value}
        </DetailLink>
      );
    },
  },
  {
    Header: "계약자 유형",
    accessor: "classifications",
    width: 160,
    sticky: "left",
    Cell: ({ value }: Cell<MbOrg>) => {
      const changeKorean = value.map((item: string) => {
        return item === "GENERAL_BIZ" ? "사업자" : item === "INDIVIDUAL" ? "개인" : "소유주";
      });

      return <div className="w-100 text-center">{changeKorean.join(", ") || "-"}</div>;
    },
  },
  {
    Header: "계약자(법인명/상호)",
    accessor: "name",
    width: 240,
    sticky: "left",
    Cell: (props: Cell<MbOrg>) => {
      return <BaseTooltip className="text-left w-100" contents={props.value ? props.value : "-"}></BaseTooltip>;
    },
  },
  {
    Header: "대표자/성명",
    accessor: "ceoName",
    width: 120,
    sticky: "left",
    Cell: (props: Cell<MbOrg>) => {
      return <BaseTooltip className="text-left w-100 ellipsis2" contents={props.value ? props.value : "-"}></BaseTooltip>;
    },
  },
  {
    Header: "국가",
    accessor: "bizLocationType",
    width: 80,
    sticky: "left",
    Cell: (props: Cell<MbOrg>) => {
      return (
        <div className="w-100 text-center">
          {props.value === BizLocationType.OVERSEAS ? "해외" : props.value === BizLocationType.DOMESTIC ? "국내" : "-"}
        </div>
      );
    },
  },
  {
    Header: "사업자 유형",
    accessor: "bizType",
    width: 100,
    sticky: "left",
    Cell: (props: Cell<MbOrg>) => {
      return <div className="w-100 text-center">{props.value === BizType.CORP ? "법인사업자" : props.value === BizType.SP ? "개인사업자" : "-"}</div>;
    },
  },

  {
    Header: "사업자 등록번호",
    accessor: "bizRegNo",
    width: 130,
    Cell: (props: Cell<MbOrg>) => {
      return <div className="w-100 text-left">{props.value ? companyRegistrationHypen(props.value) : "-"}</div>;
    },
  },
  {
    Header: "법인 등록번호",
    accessor: "corRegNo",
    width: 160,
    Cell: (props: Cell<MbOrg>) => {
      return (
        <div className="w-100 text-left">
          <span>{props.value ? corpHypen(props.value) : "-"}</span>
        </div>
      );
    },
  },
  {
    Header: "최초 등록일시",
    accessor: "createdDate",
    width: 160,
    Cell: ({ value }: Cell<MbOrg>) => {
      return <div className="w-100 text-center">{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</div>;
    },
  },
  {
    Header: "최종 수정일시",
    accessor: "lastModifiedDate",
    width: 160,
    Cell: ({ value }: Cell<MbOrg>) => {
      return <div className="w-100 text-center">{value ? moment(value).format(ViewYmdFormat.FULL) : "-"}</div>;
    },
  },
];

export default OrgColumns;
